import React, { Component } from 'react';
import Loading from '../../../../flowtrace-components/Loading';
import { Button, Grid, Switch, Link } from '@material-ui/core';
import { Launch, Assignment, Sync, Save  } from '@material-ui/icons';
import accountAPI from '../../../../flowtrace-api/Account/propertyActions';
import MuiAlert from '@material-ui/lab/Alert';


class AppSettingsAuthentication extends Component {
  constructor(props) {
    super(props);
    const account = this.props.account ? this.props.account : { props:{} };

    const chromeAPISettings = {
        authentication: {
            Value: { 
                account: account ? account.account_id : null,
                key: account.props.chromeExtensionAPIKey ? account.props.chromeExtensionAPIKey : null
            }
        }
    }
    this.state = {loading:false, copied: false, chromeAPISettings, changed: account ? false : true}; // Configuring / Onboarding
  }

  generateUUIDChromeKey = async() => {
    return (crypto.randomUUID() + crypto.randomUUID() + crypto.randomUUID()).split("-").join("");
  }

  getNotification = (step = 1) => {
    const helpUrl = "https://help.flowtrace.co/en/articles/8561179-centrally-managed-meeting-cost-extension-for-chrome";
    const helpLink = <Link underline="hover" variant="body2" target={"_blank"} href={helpUrl}> <Launch fontSize="small"/></Link>;

    // if(step === 5){
    //   return <MuiAlert className="m-2" severity="success">
    //     <div className="d-flex align-items-center align-content-center" >
    //       <strong className="d-block mb-3">Key disabled and removed</strong>
    //     </div>
    //   </MuiAlert>
    // }
    if(step === 4){
      return <MuiAlert severity="success">
        <strong className="d-block mb-3">Testing & troubleshooting help:</strong>
        <p>Go to 'chrome://policy' and click 'Reload Policies'</p>
        <p>Go to 'calendar.google.com' or refresh the window</p>
        <p>Open a calendar event with more than 2 people.</p>
        <p>Expand the cost estimate for the authentication method.</p>
        <p>Previous SSO login? Click signout from current session.</p>
        <p>Can you see "Centrally authenticated" wording?</p>
        <p>Not working? Please contact support for help.</p>
      </MuiAlert>
    }
    const step1 = "1. Copy the new configuration to clipboard";
    const step2 = "2. Add configuration to your Google Workspace";
    const step3 = "3. Save these settings to activate the key";
    const notification = 
      <MuiAlert className="m-2" severity="warning">
        <strong className="d-block mb-3">Using Centrally Managed Account Identifier Key:</strong>
        <p>{ step === 1 ? <strong>{step1}</strong> : step1 }</p>
        <p>{ step === 2 ? <strong>{step2}</strong> : step2 } { helpLink }</p>
        <p>{ step === 3 ? <strong>{step3}</strong> : step3 }</p>
      </MuiAlert>
    return notification;
  }

  saveClick = async() => {
    const status = this.getKeyStatus();
    // Remove existing key if we are replacing (or we are removing the key)
    if(status.current)
      await accountAPI.deleteProperty(this.props.account.account_id, {chromeExtensionAPIKey: status.current});
    if(status.new)
      await accountAPI.addProperty(this.props.account.account_id, {chromeExtensionAPIKey: status.new});

    this.setState({changed:false, copied:false, keyNotification:this.getNotification(status.new ? 4 : 5)});
    await this.props.reload();
  }

  handleRegenerateClick = async() => {
    const chromeAPISettings = this.state.chromeAPISettings;
    chromeAPISettings.authentication.Value.key = await this.generateUUIDChromeKey();
    this.setState({changed:true, chromeAPISettings, keyNotification:this.getNotification()});
  }

  copyToClipboard = async() => {
    const settings = JSON.stringify(this.state.chromeAPISettings, undefined, 2);
    if ('clipboard' in navigator){
      await navigator.clipboard.writeText(settings);
    } else {
      document.execCommand('copy', true, settings);
    }
    this.setState({copied:true, keyNotification:this.getNotification(2)});
  }

  handleAPIKeyChange = async(event) => {
    const enabled = event.target.checked;
    const chromeAPISettings = this.state.chromeAPISettings;
    if(enabled && !chromeAPISettings.authentication.Value.key){
      const status = this.getKeyStatus()
      // Get either existing key, or generate new
      chromeAPISettings.authentication.Value.key = status.current ? status.current : await this.generateUUIDChromeKey();
      this.setState({changed:false, chromeAPISettings});
    }
    if(!enabled && chromeAPISettings.authentication.Value.key){
      chromeAPISettings.authentication.Value.key = null;
      this.setState({changed:true, chromeAPISettings});
    }
  }
  
  loading = () => <Loading text="Saving Meeting Cost for Calendar App settings."/>;
  reloading = () => <Loading text="Reloading account settings."/>;

  getKeyStatus = () => {
    const account = this.props.account ? this.props.account : { props:{} };
    const currentAPIKey = account.props.chromeExtensionAPIKey ? account.props.chromeExtensionAPIKey : null
    const currentStateAPIKey = this.state.chromeAPISettings.authentication.Value.key;
    return {
      current: currentAPIKey,
      new: currentStateAPIKey,
      update: currentAPIKey !== currentStateAPIKey, 
      remove:currentStateAPIKey ? false : true, 
      add: !currentAPIKey && currentStateAPIKey ? true : false,
      enabled: currentStateAPIKey ? true : false,
      copied: this.state.copied
    };
  }
  requireAuthentication = () => {
    const settings = this.props.settings;
    const extensionDisabled = !settings.enabled;

    const keyStatus = this.getKeyStatus();
    const saveButtonText = keyStatus.remove ? "Save (Remove)" : "Save";
    const regenDisabled = !keyStatus.enabled || extensionDisabled ? true : false;
    const copyDisabled = !keyStatus.enabled || extensionDisabled || !keyStatus.update ? true : false;
    const saveDisabled = extensionDisabled || !keyStatus.update ? true : false;

    const ssoNotification =
      <MuiAlert className="d-block m-2" severity="info">
        <div className="d-block align-items-center align-content-center" >
          <strong className="d-block mb-3">App configuration using SSO login:</strong>
          The configuration transferred from our servers does not contain personal identifiable information (apart from the currently logged in user) and the authentication is used to match with the account configuration to load.
        </div>
      </MuiAlert>
    const centralNotification =
    <MuiAlert className="d-block m-2" severity="info">
      <div className="d-block align-items-center align-content-center" >
        <strong className="d-block mb-3">Google Workspace: Centrally Deplyed Key:</strong>
        You can choose to use Google Workspace's built-in Chrome Policies to store and distribute an access key which is used to fetch the account configuration. This key is stored as part of the extension deployment and will be used as part of the Google Calendar extension's JavaScript environment.
      </div>
    </MuiAlert>

    const requireAuthentication =
      <Grid item xs={12}>
        { this.props.createHeader("App User Identification", "These settings control how your users receive the account configuration to their Calendars. The configuration loaded from our servers does not contain sensitive information and the authentication is purely used to identify which configuration to load from our servers.", <div />) }
        <Grid container spacing={3} className="ml-3">
          <Grid item xs={4} md={2}>
            <Grid container spacing={1} direction="column" >
              {this.props.createHeader("Google SSO", "Google SSO is always available in our app.")}
              <Grid item>
                <Switch checked={true} disabled color="primary" name="chromeExtension.requireAuthentication" />
              </Grid>
              {this.props.createHeader("Microsoft SSO", "Microsoft tenant administrators deploy Outlook Add-in centrally and grant users the required access to the oauth2 app using Entra SSO OBO flow.")}
              <Grid item>
                <Switch checked={true} disabled color="primary" name="chromeExtension.requireAuthentication" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={8} md={3}>
            { ssoNotification } 
          </Grid>
          <Grid item xs={4} md={3}>
            <Grid container spacing={1} direction="column" >
              {this.props.createHeader("Google Calendar Key", "You need administrator access to your Google Workspace to configure the automatic key based identification. You can use centralised authentication methods as part of the team, and scale plans.")}
              <Grid item xs={12}>
                <Switch checked={keyStatus.enabled} disabled={extensionDisabled} onChange={this.handleAPIKeyChange} color="primary" name="chromeExtensionAPIKey" />
              </Grid>
              <Grid item >
                <Button fullWidth disabled={regenDisabled} onClick={async() => await this.handleRegenerateClick()} variant="contained" color="secondary"><Sync className="mr-2"/>Regenerate account identifier key</Button>
              </Grid>
              <Grid item>
                <Button fullWidth disabled={copyDisabled} onClick={async() => {await this.copyToClipboard()}} variant="contained" color="secondary"><Assignment className="mr-2"/>Copy to Clipboard</Button>
              </Grid>
              <Grid item>
                <Button fullWidth disabled={saveDisabled} onClick={async() => {await this.saveClick()}} variant="contained" color="secondary"><Save className="mr-2"/>{saveButtonText}</Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={8} md={4}>
            <Grid container spacing={1} direction="column" >
              { this.state.keyNotification ? 
                <Grid item> {this.state.keyNotification} </Grid>
                : keyStatus.current ? this.getNotification(4) : centralNotification }
            </Grid>
          </Grid>

        </Grid>
      </Grid>
      return requireAuthentication;
  }

  render() {
    if (this.props.loading)
      return this.props.loading();

    return this.requireAuthentication();
  }
}

export default AppSettingsAuthentication;
